import Api from "../..";
import { TransmedRegistrationLcInput, TransmedRegistrationSubmitInput } from "../../../dtos/transmed/process/registration/registration";

export default class TransmedRegistrationCreateApi extends Api {
  constructor() {
    super("transmed/registration/create");
  }

  public async post(data: TransmedRegistrationLcInput): Promise<void> {
    await super.post(data);
  }

  public async put(id: string, data: TransmedRegistrationSubmitInput): Promise<void> {
    await super.put(id, data);
  }
}
